import React from "react";

export enum UserTypeE{
  MySelf = 0,
  Client = 1
}

interface UserTypeProp {
	userType: string;
  valueSelected(response?: any): void;
}

const UserType: React.FC<UserTypeProp> = ({ userType, valueSelected }): JSX.Element => {
  const valueClicked = (userType: UserTypeE) =>{
    valueSelected(userType);
  }

	return (
		<div className="content">
			<div className="button-row">
				<div className="button">
					<button className="greenButton" onClick={(e) => valueClicked(UserTypeE.MySelf)}>
						Myself
					</button>
				</div>
				<div className="button">
					<button className="greenButton" onClick={(e) => valueClicked(UserTypeE.Client)}>
						Client
					</button>
				</div>
			</div>
		</div>
	);
};

export default UserType;
